import { ratingVariationSwiper } from '@sections/testimonials/swiper';
import { defaultVariationSwiper } from '@sections/testimonials/default/swiper';

document.addEventListener("DOMContentLoaded", function(_event) {
  // Trigger the correct swiper js if we are on 3 cards view or more than 3 cards view.
  if (document.getElementsByClassName('default-swiper-testimonial').length > 0) {
    defaultVariationSwiper();
  } else if (document.getElementsByClassName('without-ratings-swiper-testimonial').length > 0 ||
    document.getElementsByClassName('with-ratings-swiper-testimonial').length > 0) {
    ratingVariationSwiper();
  }
});
